export default "__VITE_ASSET__7g_7blH0__"